import { api } from '@/lib/api';

/**
 * API client do módulo `agent-health-monitor` (Opção B).
 *
 * Expõe endpoints pra listar alertas de drift de produção + reconhecer
 * (acknowledge). Mesma estratégia dos outros módulos agent-*: tipos
 * locais espelhando o backend (não vão pro @troia-v3/types).
 */

export type DriftMetric =
  | 'relevance'
  | 'hallucination'
  | 'tone'
  | 'toolUsage'
  | 'answerCompleteness'
  | 'conversationAdvancement'
  | 'scopeAdherence'
  | 'conciseness'
  | 'knowledgeRetention'
  | 'humanization'
  | 'faithfulness'
  | 'agentGoalAccuracy'
  | 'actionCompleteness'
  | 'overallScore';

export interface DriftMetricDelta {
  metric: DriftMetric;
  from: number;
  to: number;
  delta: number;
  currentSampleSize: number;
  previousSampleSize: number;
}

export type DriftAlertSeverity = 'warning' | 'danger';

export interface AgentDriftAlertResponse {
  id: string;
  agentId: string;
  agentName: string;
  severity: DriftAlertSeverity;
  regressedMetrics: DriftMetricDelta[];
  improvedMetrics: DriftMetricDelta[];
  currentOverallScore: number;
  previousOverallScore: number;
  currentSampleSize: number;
  previousSampleSize: number;
  currentPeriodStart: string;
  currentPeriodEnd: string;
  createdAt: string;
  acknowledgedAt: string | null;
  acknowledgedBy: string | null;
  notifiedAt: string | null;
}

export interface ListAlertsResponse {
  items: AgentDriftAlertResponse[];
  total?: number;
}

export const agentHealthMonitorApi = {
  /**
   * Lista alertas ativos (não acknowledged) do tenant inteiro.
   * Usado pelo badge global no sino + menu de notificações.
   */
  async listActiveByTenant(limit = 50): Promise<ListAlertsResponse> {
    const response = await api.get('agent-health-monitor/drift-alerts/my', {
      params: { limit },
    });
    return response.data.data;
  },

  /**
   * Lista alertas ativos de um agente específico. Usado pela HealthTab
   * do `AgentFormPage` pra mostrar banner de alerta proativo.
   */
  async listByAgent(agentId: string): Promise<ListAlertsResponse> {
    const response = await api.get(
      `agent-health-monitor/${agentId}/drift-alerts`,
    );
    return response.data.data;
  },

  /**
   * Marca alerta como reconhecido pelo usuário. Some do banner ativo
   * mas continua no histórico.
   */
  async acknowledge(agentId: string, alertId: string): Promise<void> {
    await api.post(
      `agent-health-monitor/${agentId}/drift-alerts/${alertId}/acknowledge`,
    );
  },
};
